export default "__VITE_ASSET__wBhnIEQb__"